export const HomeSectionConstant = {
  MinItemCount: 3,
} as const
